import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

interface PaymentTypeConfig {
  isAllowed?: boolean;
  isEnable?: boolean;
}

interface PaymentConfig {
  bankPayment?: PaymentTypeConfig | null;
  cardPayment?: PaymentTypeConfig | null;
  cashPayment?: PaymentTypeConfig | null;
  cashOnDeliveryPayment?: PaymentTypeConfig | null;
  internalPayment?: PaymentTypeConfig | null;
}

const isPaymentTypeEnabled = (config?: PaymentTypeConfig | null) =>
  config?.isAllowed || config?.isEnable;

export function getOrderPaymentTypeOptions(paymentConfig: PaymentConfig | Nullish) {
  if (!paymentConfig) {
    return [];
  }

  const options = [];

  const isBankPaymentEnabled = isPaymentTypeEnabled(paymentConfig.bankPayment);
  const isCardPaymentEnabled = isPaymentTypeEnabled(paymentConfig.cardPayment);
  const isCashPaymentEnabled = isPaymentTypeEnabled(paymentConfig.cashPayment);
  const isCashOnDeliveryPaymentEnabled = isPaymentTypeEnabled(paymentConfig.cashOnDeliveryPayment);
  const isInternalPaymentEnabled = isPaymentTypeEnabled(paymentConfig.internalPayment);

  if (isBankPaymentEnabled) {
    options.push({
      label: i18n.t('entity.invoice.paymentMethod.bankTransfer'),
      value: 'BANK_TRANSFER',
    });
  }

  if (isCardPaymentEnabled) {
    options.push({
      label: i18n.t('entity.invoice.paymentMethod.card'),
      value: 'CARD',
    });
  }

  if (isCashPaymentEnabled) {
    options.push({
      label: i18n.t('entity.invoice.paymentMethod.cash'),
      value: 'CASH',
    });
  }

  if (isCashOnDeliveryPaymentEnabled) {
    options.push({
      label: i18n.t('entity.invoice.paymentMethod.cashOnDelivery'),
      value: 'CASH_ON_DELIVERY',
    });
  }

  if (isInternalPaymentEnabled) {
    options.push({
      label: i18n.t('general.labels.internal'),
      value: 'INTERNAL',
    });
  }

  return options;
}
